import { render, staticRenderFns } from "./YMmpArticleItem.vue?vue&type=template&id=0d53ca3e&scoped=true&"
import script from "./YMmpArticleItem.vue?vue&type=script&lang=js&"
export * from "./YMmpArticleItem.vue?vue&type=script&lang=js&"
import style0 from "./YMmpArticleItem.vue?vue&type=style&index=0&id=0d53ca3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53ca3e",
  null
  
)

export default component.exports